import React from 'react';

class InvalidPage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const mainText = `Unfortunately, this product is currently not available in your region`;
    return (
      <div className='invalid-page-container'>
        <div className='navbar-section'>
          <div className='navbar-content'>
            <a href='/' style={{ textDecoration: 'none' }}>
              <div className='logo-container'>
                <img
                  className='logo-img'
                  src={require('../../images/trybe-logo-white.svg')}
                />
                <div className='logo-text'>TRYBE</div>
              </div>
            </a>
          </div>
        </div>
        <div className='main-body'>
          <img
            src={require('../../images/error.png')}
            className='error-image'
          />
          <div className='main-text'>{mainText}</div>
        </div>
      </div>
    );
  }
}

export default InvalidPage;



// WEBPACK FOOTER //
// ./src/components/coachSalesPages/InvalidPage.js